module.exports = __webpack_public_path__ + "img/Image 18.5d55626e.png";